import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { guaranteeChips } from '../data/salesCopy';
export function Guarantee() {
  return <section className="w-full border-y border-line bg-night-deep" data-id="element-104" data-mp="1o3dm4a5km9q3">
      <div className="mx-auto max-w-3xl px-4 py-10 text-center sm:px-5 sm:py-16" data-id="element-105" data-mp="222darht32om9">
        <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full border border-gold/40 bg-panel text-gold" data-id="element-106" data-mp="1x3tothehpctw">
          <ShieldCheckIcon className="h-7 w-7" aria-hidden="true" data-id="element-107" data-mp="19fipiiofzl7q" />
        </span>
        <p className="mt-5 text-[10px] font-semibold uppercase tracking-[0.28em] text-gold sm:text-xs" data-id="element-108" data-mp="14gpdyvspu4a7">
          Zero risk · 10 days protected
        </p>
        <h2 className="mt-4 font-display text-2xl uppercase leading-tight tracking-tight text-cream sm:text-4xl" data-id="element-109" data-mp="1j6dcjp9iiou8">
          10-day money-back <span className="text-gold" data-id="element-110" data-mp="qnhmd44mx8si">guarantee</span>
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-[15px] leading-relaxed text-cream-muted sm:text-base" data-id="element-111" data-mp="qlwu5l5sm1xt">
          Try TeachersKit for 10 days. If your students aren’t more engaged, or if you don’t save at
          least 5 hours of planning a week, just email{' '}
          <a href="mailto:support@stockdigital.shop" className="font-medium text-gold underline decoration-gold/40 underline-offset-4 transition-colors duration-150 ease-expo hover:decoration-gold" data-id="element-112" data-mp="tx1nykd4y81w">
            support@stockdigital.shop
          </a>
          . We’ll refund every cent — no questions asked.
        </p>
        <ul className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-113" data-mp="az8ipbf1hm1c">
          {guaranteeChips.map(chip => <li key={chip} className="rounded-full border border-line bg-panel px-3.5 py-1.5 text-[10px] font-semibold uppercase tracking-[0.1em] text-cream sm:text-xs" data-id="element-114" data-mp="f12g9atxu9xa">
              {chip}
            </li>)}
        </ul>
      </div>
    </section>;
}